var map = {
	"./Bad.jpg": 9297,
	"./Good luck.jpg": 7306,
	"./Good.jpg": 4053,
	"./Goodbye.jpg": 2045,
	"./Hello.jpg": 244,
	"./How are you.jpg": 5529,
	"./I love you.jpg": 7476,
	"./Like.jpg": 9251,
	"./Please.jpg": 6456,
	"./Stop.jpg": 6622,
	"./Thanks.jpg": 2973,
	"./come.jpg": 8690,
	"./happy.jpg": 2582,
	"./have.jpg": 5464,
	"./me.jpg": 3152,
	"./sad.jpg": 9192,
	"./see.jpg": 4465,
	"./smile.jpg": 5080,
	"./teacher.jpg": 8986,
	"./you.jpg": 3581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9205;